interface AuthLayoutProps {
  children: React.ReactNode;
}

const AuthLayout = ({ children }: AuthLayoutProps) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary/10 via-background to-accent/10">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="inline-flex h-16 w-16 items-center justify-center rounded-soft bg-primary mb-4">
            <span className="text-2xl font-bold text-primary-foreground">
              JOM
            </span>
          </div>
          <h1 className="text-3xl font-heading font-bold text-foreground">
            ADMINISTRACION
          </h1>
          <p className="text-muted-foreground mt-2">Bienvenido de vuelta</p>
        </div>

        {/* Contenido (formulario de login, etc.) */}
        <div className="bg-card rounded-soft shadow-medium border border-border p-8">
          {children}
        </div>

        {/* Footer */}
        <div className="text-center mt-6 text-sm text-muted-foreground">
          ¿Necesitas ayuda?{" "}
          <a href="#" className="text-primary hover:underline">
            Contacta a soporte
          </a>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
